@if (should_be_shown()) {
  <span
    class="pending-changes-save-status"
    [class.pending-changes-save-status--error]="status_state().is_error()"
    [matTooltip]="tooltip_value()"
    [matTooltipDisabled]="!has_tooltip()"
    matTooltipPosition="below"
  >
    <mat-icon
      class="pending-changes-save-status__icon"
      [class.pending-changes-save-status__icon--saving]="status_state().is_saving()"
      aria-hidden="true"
    >
      {{ status_state().icon() }}
    </mat-icon>

    @if (label()) {
      <span class="pending-changes-save-status__label" [style.max-width]="label_max_width()">{{ label() }}</span>
    }
  </span>
}
